<template>
  <section class="grid-flex column">
    <section
      
      class="flex column w100"
    >
      <div class="box flex-1 w100">
        <div class="box-content">

          <div class="flex-1 w100">
            <p>
              Adicione seus pixels do FACEBOOK ADS  e TAGs do Google Ads
            </p>
            <p class="margin-top-s">
              Você vai poder usar eles na retro alimentação e substituir o GTM para a instalação no seu site.
            </p>
          </div>

          <div class="flex-1 w100 margin-top-l">
            <div class="flex middle">
              <div class="flex-1">
                <tabs :data="populateTabs" v-model="currentTab"></tabs>
              </div>
            </div>
          </div>
          <div 
            v-if="currentTab === 'FBADS' || currentTab === 'GADS'"
            class="flex-1 w100 margin-top-s"
          >
            <div class="flex-1 w100">
              <div class="flex flex-1 middle between">
                <div class="button primary" @click="openModalCreate()">
                  {{ currentTab=='FBADS'? 'Criar novo Pixel' : 'Criar nova Tag' }}
                </div>
                <div class="flex column no-mobile">
                  Quantidade de Pixels: {{ account.used_limits.limit_pixels_retro | number }} / {{ account.plan_limits.limit_pixels_retro | number }}
                  <div class="margin-top-s">Precisa de mais Pixels? <router-link :to="{ name: 'SubscriptionRedirect' }">Faça Upgrade</router-link></div>
                </div>
              </div>
            </div>
            <ul>
              <li v-for="(pixel, index) in listPixels" :key="index">
                <div class="box margin-top-m item-box">
                  <div class="box-content">
                    <div class="flex middle row">
                      <div class="flex-3">
                        <div class="flex middle row">
                          <div class="flex-1 name margin-top-s flex middle">
                            <div class="switch-pixel">
                              <m-switch
                                  v-if="!loading"
                                  v-model="pixel.is_active"
                                  @change="changeIsActive(pixel)"
                                ></m-switch>
                            </div>
                            <div>
                              <p>
                                {{ pixel.name }}
                              </p>
                              <small><b>{{ pixel.type_pixel }}</b></small>
                            </div>
                          </div>
                          <div class="flex-2 margin-top-s">
                            <div class="flex details between">
                              <div class="flex column">
                                <div>{{ pixel.type_pixel === 'FBADS' ? 'Pixel ID' : 'TAG ID' }}</div>
                                <div>{{ pixel.pixel_id }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="action margin-top-s">
                        <div class="flex end">
                          <div class="button primary" @click="openToEdit(pixel)">EDITAR</div>
                          <div class="button primary" @click="openToDelete(pixel)" style="margin-left:8px">DELETAR</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
        </div>
          <div v-if="isEmpty" class="margin-top-m">
            <div >
              <p>
                Não encontramos nenhum pixel criado. Crie seu primeiro pixel para começar a rotina de retro alimentação.
              </p>
            </div>
          </div>

          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>

        </div>
      </div>
    </section>


    <!-- modal create / edit -->
    <modal
        :title="titleModal"
        :show="showModalCreateOrUpdate"
        @close="closeToEdit()"
      >
        <div class="content flex " slot="content">
          <div class="flex column w100">
            <form autocomplete="off" class="w100">
              <div class="flex-1 w100">
                <label>Nome</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newPixel.name"
                  autocomplete="off"
                />
              </div>

              <div v-if="currentTab === 'FBADS'" class="flex-1 w100 margin-top-m">
                <label>Pixel ID</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newPixel.pixel_id"
                  autocomplete="off"
                />
              </div>

              <div v-if="currentTab === 'FBADS'">
                <div class="flex-1 w100 margin-top-m">
                  <label>Token</label>
                  <input
                    class="input"
                    id="name"
                    type="text"
                    v-model="newPixel.api_key"
                    autocomplete="off"
                  />
                  </div>
                  <div class="flex-1 w100 margin-top-m">
                    <div>
                      <label>Dominio:</label>
                    </div>
                    <input
                      class="input"
                      id="name"
                      type="text"
                      v-model="newPixel.domains"
                      autocomplete="off"
                    />
                    <small>Limita os disparos apenas para acessos destes dominios.</small>
                </div>
              </div>

              <div v-if="currentTab == 'GADS'">
                <div class="flex-1 w100 margin-top-m">
                  <label>Tag Id</label>
                  <input
                    class="input"
                    id="name"
                    type="text"
                    v-model="newPixel.pixel_id"
                    autocomplete="off"
                  />
                </div>
                <div class="flex-1 w100 margin-top-m">
                    <div>
                      <label>Dominio:</label>
                    </div>
                    <input
                      class="input"
                      id="name"
                      type="text"
                      v-model="newPixel.domains"
                      autocomplete="off"
                    />
                    <small>Limita os disparos apenas para acessos destes dominios.</small>
                </div>
              </div>
            </form>
            <div class="flex w100 center margin-top-l">
              <div class="button primary" @click="saveOrUpdatePixel()">{{isEdit ? 'SALVAR': 'CRIAR'}}</div>
            </div>
          </div>
        </div>
      </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar esse pixel?"
      @cancel="
        showModalDelete = false;
        selectedPixel = null;
      "
      @accept="deletePixel(selectedPixel.id)"
    ></modal-confirm>

  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";
import Tabs from "@/components/tabs/Tabs";
import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";
import MSwitch from "@/components/MSwitch.vue";

import {
  getPixels,
  createPixel,
  updatePixel,
  deletePixel,
} from "@/services/populatePixel";

const EMPTY_PIXEL = {
  name: "",
  is_active: true,
  is_active_retro: true,
  pixel_id: "",
  api_key: "",
  conversion_code: "",
  type_pixel: "",
  product_name: "",
  domains: "",
  tax_value_conversion: "",
  tax_qtn_purchase: "",
  only_approved_sales: ""
};

export default {
  name: "populate-pixel",
  components: {
    Tabs,
    Modal,
    ModalConfirm,
    MSwitch
  },
  data() {
    return {
      loading: false,
      currentTab: "FBADS",
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      selectedPixel: null,
      populateTabs: [
        {
          name: "FBADS",
          title: "Facebook Ads",
        },
        {
          name: "GADS",
          title: "Google Ads",
        },
      ],
      newPixel: Object.assign({}, EMPTY_PIXEL),
      pixels: [],
      totalPixels: 0,
      totalLogs: 0,
    };
  },
  mounted() {
    this.getPixels()
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    listPixels() {
      return this.pixels.filter(e => e.type_pixel	=== this.currentTab)
    },
    isEmpty() {
      return this.totalPixels === 0 && !this.loading;
    },
    isEmptyLog() {
      return this.totalLogs === 0 && !this.loadingLogs;
    },
    isEdit() {
      if (this.newPixel && this.newPixel.id) {
        return true
      }
      return false
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.limit_pixels_retro <= this.account.used_limits.limit_pixels_retro) {
        return true
      }

      return false
    },
    titleModal() {
      if (this.currentTab == 'FBADS') {
        return this.isEdit ? 'EDITAR PIXEL': 'CRIAR PIXEL'
      } else {
        return this.isEdit ? 'EDITAR TAG': 'CRIAR TAG'
      }
    }
  },
  methods: {
    openModalCreate() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de Pixels do seu plano! Faça upgrade para criar mais!'
        })

        return

      }
      
      this.showModalCreateOrUpdate = true
    },
    openToDelete(pixel) {
      this.showModalDelete = true
      this.selectedPixel = pixel
    },
    openToEdit(pixel) {
      this.showModalCreateOrUpdate = true
      this.newPixel = pixel
    },
    closeToEdit() {
      this.showModalCreateOrUpdate = false
      this.newPixel = Object.assign({}, EMPTY_PIXEL)
    },
    changeIsActive(pixel) {
      this.newPixel = pixel
      this.updatePixel(this.newPixel.id)
    },
    saveOrUpdatePixel() {
      if (this.isEdit) {
        this.updatePixel(this.newPixel.id)
      } else {
        this.createPixel()
      }
      this.closeToEdit()
    },
    getPixels() {
      this.loading = true
      getPixels()
        .then((result) => {
          this.pixels = result.pixels;
          this.totalPixels = result.total;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false
        })
    },
    createPixel() {
      let params = {
        name: this.newPixel.name,
        pixel_id: this.newPixel.pixel_id,
        api_key: this.newPixel.api_key,
        conversion_code: this.newPixel.conversion_code,
        product_name: this.newPixel.product_name,
        is_active: this.newPixel.is_active,
        is_active_retro: this.newPixel.is_active_retro,
        domains: this.newPixel.domains,
        type_pixel: this.currentTab,
      };

      createPixel(params)
        .then((result) => {
          this.pixels.push(result);

          this.$toast.success({
            title: "Sucesso",
            message: "Pixel criado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    updatePixel(pixelId) {
      let params = {
        name: this.newPixel.name,
        pixel_id: this.newPixel.pixel_id,
        is_active: this.newPixel.is_active,
        is_active_retro: this.newPixel.is_active_retro,
        api_key: this.newPixel.api_key,
        product_name: this.newPixel.product_name,
        domains: this.newPixel.domains,
        conversion_code: this.newPixel.conversion_code,
        type_pixel: this.currentTab,
        tax_value_conversion: this.newPixel.tax_value_conversion,
        tax_qtn_purchase: this.newPixel.tax_qtn_purchase,
        only_approved_sales: this.newPixel.only_approved_sales
      };

      updatePixel(pixelId, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Pixel editado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    deletePixel(pixelId) {
      deletePixel(pixelId)
        .then(() => {
          this.pixels = this.pixels.filter(p => p.id != pixelId)

          this.$toast.success({
            title: "Sucesso",
            message: "Pixel deletado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.showModalDelete = false;
          this.selectedPixel = null;
        }) ;
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
}

.item-box {
  border-radius: 5px;
  border: 1px solid #eee;
}


.max-table {
  overflow-y: scroll;
  max-height: 400px;
  padding-bottom: 16px;
}

.switch-pixel {
  margin-right: 14px;
}

</style>
